export default {
    error: {
        generic:
            "Este segmento dejó de actualizarse. Contacta al soporte si el problema continúa.",
        points_program_inactive:
            "Este segmento dejó de actualizarse porque usa el saldo de puntos como condición, y el programa de puntos está desactivado. Reactiva el programa o elimina esa condición para volver a actualizarlo.",
        short: {
            generic: "Actualización pausada.",
            points_program_inactive: "Actualización pausada: programa de puntos desactivado.",
        },
    },
    create_modal: {
        title: "Crear Segmento",
        label: "Por favor, escriba el nombre del segmento",
        loading: "Creando segmento, esto puede tardar unos instantes...",
        cancel: "Cancelar",
        create: "Crear",
        trigger: "Crear Segmento",
        success: "¡Segmento creado con éxito!",
        internal_error: "¡Error interno del servidor, inténtelo de nuevo más tarde!",
    },
    list: {
        delete_title: "Desea eliminar este segmento?",
        delete_body:
            "Esta accion es irreversible y eliminara permanentemente este segmento y todos los datos relacionados.",
        title: "Segmentos de clientes",
        add_button: "Agregar",
        add_aria: "Agregar segmento",
        search_placeholder: "Buscar segmento por nombre...",
        search_aria: "Buscar segmento por nombre",
        max_reached_prefix: "Has alcanzado el maximo de",
        max_reached_suffix: "formularios",
        segment_contacts_tooltip: "Ver contactos de este segmento",
        last_30_days: "Movimientos en los últimos 30 días",
        joined: "Entraron:",
        left: "Salieron:",
        clients: "clientes",
        edit: "Editar",
        delete: "Eliminar",
        edit_segment_aria: "Editar segmento {0}",
        delete_segment_aria: "Eliminar segmento {0}",
        deleted_success: "Segmento eliminado",
        delete_in_use_by_tier: "Este segmento lo usa el nivel {name}. Para eliminarlo, elimina primero el nivel en el Centro de Beneficios.",
        delete_error: "No fue posible eliminar el segmento.",
        manual_badge: "Manual",
        dynamic_badge: "Dinámico",
        manage_members: "Gestionar miembros",
        manage_members_aria: "Gestionar miembros del segmento {0}",
        add_members: "Agregar miembros",
        remove_members: "Eliminar miembros",
        columns_name: "Nombre",
        columns_type: "Tipo",
        columns_clients: "Clientes",
        columns_movements: "Movimientos",
        columns_actions: "Acciones",
        columns_created_at: "Creado el",
        filters_type: "Tipo",
        filters_created_period: "Fecha de creación",
    },
    members: {
        modal_add_title: "Agregar miembros al segmento",
        modal_remove_title: "Eliminar miembros del segmento",
        title: "Gestionar miembros del segmento",
        back: "Volver a segmentos",
        add_button: "Agregar clientes filtrados",
        remove_button: "Eliminar clientes filtrados",
        confirm_add_title: "¿Agregar clientes al segmento?",
        confirm_add_body: "Esto agregará {0} clientes filtrados a este segmento.",
        confirm_remove_title: "¿Eliminar clientes del segmento?",
        confirm_remove_body: "Esto eliminará {0} clientes filtrados de este segmento.",
        add_success: "{0} clientes agregados ({1} ya estaban en el segmento).",
        remove_success: "{0} clientes eliminados ({1} no estaban en el segmento).",
        saving_add: "Agregando clientes al segmento...",
        saving_remove: "Eliminando clientes del segmento...",
        saving_hint: "Esto puede tardar un momento para audiencias grandes.",
        dynamic_error: "Solo los segmentos manuales permiten gestionar miembros.",
        error: "No se pudo actualizar la membresía del segmento.",
    },
    form: {
        add_title: "Agregar segmento",
        name_helper: "Elija un nombre para identificar su segmento",
        name_placeholder: "Nombre del segmento",
        update_daily: "Actualizar diariamente?",
        type_help: "Los segmentos dinámicos recalculan la membresía diariamente. Los segmentos manuales mantienen una lista fija de clientes.",
        manual_populate_label: "¿Cómo debe comenzar este segmento manual?",
        start_empty: "Comenzar vacío",
        populate_from_filters: "Poblar desde filtros",
        yes: "Sí",
        no: "No",
        audience: "Publico:",
        ai_placeholder:
            "Quien no compra hace 90 dias y tiene dos compras o mas",
        ai_filter: "Filtrar",
        ai_use: "Usar IA",
        ai_error_prefix:
            "No fue posible generar filtros exactos para esta descripcion.",
        ai_error_hint: "Tal vez quiera:",
        loading_sentences: {
            s1: "Analizando los filtros disponibles...",
            s2: "Identificando los mejores criterios...",
            s3: "Procesando datos de clientes...",
            s4: "Seleccionando algoritmos de segmentacion...",
            s5: "Refinando los parametros...",
            s6: "Aun procesando, esto puede tardar un poco...",
            s7: "Su paciencia sera recompensada...",
            s8: "Finalizando los ultimos detalles...",
            s9: "En serio, casi listo...",
            s10: "Solo un minutito mas...",
            s11: "No se rinda, ya casi llegamos...",
        },
        empty_state: "Agregue filtros o grupos para crear su condicion",
        calculating_target: "Calculando publico objetivo...",
        save: "Guardar",
        updating: "Actualizando...",
        creating: "Creando...",
        filters_generated_success: "Filtros generados con exito!",
        filters_generated_error: "Error al generar filtros. Intente nuevamente.",
        server_error_prefix: "Error al comunicarse con el servidor:",
        save_error_log: "Error al guardar segmento:",
        invalid_filters_log: "Filtros invalidos recibidos:",
    },
    filters: {
        orders_count: "Numero de pedidos",
        quotations_count: "Numero de presupuestos",
        quotations_amount: "Valor de presupuestos",
        rfm_group: "Grupo RFM",
        campaign_interactions: "Interacciones de campaña",
        days_after_field: "Dias despues de {0}",
        custom_event: "Evento personalizado",
        purchased_product: "Compro producto",
        filled_form: "Respondió un formulario",
        customer_profile: "Perfil del cliente",
        profile_complete: "Con registro completo",
        profile_incomplete: "Sin registro completo",
        profile_with_phone: "Con telefono",
        profile_with_email: "Con correo electronico",
        points_balance: "Saldo de puntos",
        average_ticket: "Ticket medio",
        clv_total_spent: "Gasto acumulado (CLV)",
        branches: "Sucursales",
        days_since_last_order: "Dias desde el ultimo pedido",
        days_since_first_order: "Dias desde el primer pedido",
        days_until_next_order: "Dias previstos hasta el proximo pedido",
        days_since_created: "Dias desde el registro",
        age: "Edad",
        birthday_month: "Cumpleañeros del mes",
        communication_channels: "Canales de comunicacion",
        accepted: "Aceptado",
        and: "y",
        between: "entre",
        birthdays_of_month: "Cumpleañeros del mes",
        close: "Cerrar",
        conditions_count: "{count} condición(es) de respuesta",
        days_ago: "días atrás",
        event: "Evento",
        form: "Formulario",
        no_questions: "Este formulario no tiene preguntas para filtrar.",
        question_conditions: "Respuestas de las preguntas (opcional)",
        select_form: "Seleccione un formulario",
        which_form: "Qué formulario",
        executions: "Ejecuciones",
        from: "desde",
        indifferent: "Indiferente",
        inform_values: "Informar valores",
        limit_by_values: "Limitar por valores",
        limit_time_range: "Limitar rango de tiempo",
        more_than: "más que",
        not_accepted: "No aceptado",
        period_label: "Período",
        purchase_quantity: "Cantidad de compras",
        purchases: "Compras",
        search_combined_info: "Buscar información combinada",
        search_event: "Buscar evento",
        select_values: "Seleccionar valores",
        until: "hasta",
        which_brand: "Qué marca",
        which_category: "Qué categoría",
        which_event: "Qué evento",
        which_product: "Qué producto",
        which_status_to_execute: "Qué estado ejecutar",
        order_custom_fields: "Campos personalizados del pedido",
        op_starts_with: "Empieza con",
        op_date_on: "En",
        op_date_after: "Después de",
        op_date_before: "Antes de",
        select_operator: "Seleccionar operador",
        select_date: "Seleccionar fecha",
        enter_value: "Ingresar valor",
        add_custom_field: "Agregar campo personalizado...",
        no_custom_fields_added: "Ningún campo personalizado agregado.",
        remove_custom_field: "Quitar campo",
    },
};
